import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {Service} from '../../../../domain/model/common/service.class';
import {SectionService} from '../../../../domain/model/common/section-service.class';
import {UserSearchQuery} from '../../../../domain/model/user/user.service';
import {Page} from '../../../../domain/model/common/search/page.class';
import {UserSearchModel} from './user-search.model';

/**
 * Created by Rodrigo Quesada on 20/03/17.
 */
@Injectable()
export class UserSearchSectionService extends SectionService {

    constructor(svcm: Service.InjectedMembers) {
        super(svcm, 'userSearch');
    }

    searchUsers(query: UserSearchQuery): Observable<Page<UserSearchModel>> {
        return this.getPage(UserSearchModel, 'search', undefined, query.asParams());
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/pages/admin/search/model/user-search-section.service.ts